var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"FV-paneContentWr FV-side FV-"
    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"FV-paneContent FV-"
    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
    + "\">\n        <div data-content=\""
    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
    + "\" class=\"FV-panel-"
    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
    + "\"></div>  <!-- This is where to insert -->\n    </div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelCommon/template.hbs
 ** module id = 747
 ** module chunks = 0
 **/